import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { css, angle, pythagorasTheorem } from 'Common/Utils';
import style from './index.module.css';

export const Arrow = ({ target: targetRef, find, from, to }) => {
	const ref = React.createRef();
	const lineref = React.createRef();
	useEffect(() => {
		const reference = ref.current;
		const target = targetRef.current;
		const line = lineref.current;
		if (!(reference && target && line)) return;
		const fi =
			(find &&
				(typeof find === 'function'
					? find(target)
					: target.querySelector(find))) ||
			target;
		const f = from && from(target);
		const t = to && to(target);
		const targetRect = fi.getBoundingClientRect();
		const fromRect = f.getBoundingClientRect();
		const toRect = t.getBoundingClientRect();
		const isUpward = fromRect.top > toRect.top;

		const defaultpos = {
			y:
				fromRect.top -
				(fromRect.height > 20 ? -10 : fromRect.height / 2) -
				targetRect.top,
			x:
				fromRect.left +
				(fromRect.width > 200 ? 0 : fromRect.width / 2) -
				targetRect.left -
				targetRect.width / 2,
		};
		const topos = {
			y: toRect.top - toRect.height / 2 - targetRect.top,
			x:
				toRect.left + toRect.width / 2 - targetRect.left - targetRect.width / 2,
		};
		const linepath =
			Math.abs(pythagorasTheorem(defaultpos, topos)) +
			(isUpward ? toRect.height : 0);
		css(reference, {
			top: `${defaultpos.y}px`,
			left: `${defaultpos.x}px`,
			transition: 'transform 1s ease-out',
			transform: `rotate(180deg)`,
		});
		css(line, {
			width: `${linepath}px`,
		});
		const timeout = setTimeout(() => {
			css(reference, {
				transition:
					'transform 200ms ease-in, width 300ms cubic-bezier(0.82, 0.07, 0.61, 1.93) 100ms',
				transform: `rotate(${angle(defaultpos, topos)}deg)`,
				width: `${linepath}px`,
			});
		}, 1000);
		return () => clearTimeout(timeout);
	}, [targetRef, from, to, ref, find, lineref]);

	return (
		<div ref={ref} className={style.arrowGesture}>
			<i className={`mytabworks icon-ship ${style.ship}`} />
			<div ref={lineref} className={style.arrowPath}></div>
			<i className={`mytabworks icon-anchor ${style.anchor}`} />
		</div>
	);
};

Arrow.propTypes = {
	target: PropTypes.any.isRequired,
	find: PropTypes.func,
	from: PropTypes.func.isRequired,
	to: PropTypes.func.isRequired,
};
